import { DEFAULT_SETTINGS_FOR_EARNINGS_DATA } from '../../../earnings-common/constants'
import { EarningsDataSettings, EarningsTimeframeEnum } from '../../../earnings-common/types'

export const SETTINGS_COOKIE_KEY = 'quoteStatementsTableSettings'

export const DEFAULT_SETTINGS = {
  ...DEFAULT_SETTINGS_FOR_EARNINGS_DATA,
  timeframe: EarningsTimeframeEnum.annual,
}

export type StatementsType = EarningsDataSettings & {
  timeframe: EarningsTimeframeEnum
}

export enum StatementsSourceEnum {
  Reuters = 'R',
  FactSet = 'F',
}
